<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">
        {{ !item?.id ? $t('supplierAccountCreateModalTitle') : $t('supplierAccountEditModalTitle') }}
      </div>
    </template>
    <Spinner v-if="dataIsSending"/>
    <div v-else class="p-formgrid p-grid p-pt-3">
      <div class="p-field p-col-12 p-mb-5">
        <div class="p-float-label">
          <InputText id="link_name" :class="{'p-invalid' : submitted && !linkData.name}" v-model.trim="linkData.name" autocomplete="off"/>
          <label for="link_name">{{ $t('Name') }}<span class="warning-color">*</span></label>
        </div>
        <small class="p-invalid" v-if="submitted && !linkData.name">{{ $t('Required field') }}</small>
      </div>
<!--      <div class="p-field p-col-12 p-mb-5">-->
<!--        <div class="p-float-label">-->
<!--          <InputText id="link_url" v-model.trim="linkData.url" autocomplete="off"/>-->
<!--          <label for="link_url">URL</label>-->
<!--        </div>-->
<!--      </div>-->
      <div class="p-field p-col-12 p-mb-5">
        <div class="p-float-label">
          <InputText id="link_url"
                     v-model.trim="linkData.url"
                     :class="{'p-invalid': submitted && !websiteLooksValid(linkData.url)}"
                     autocomplete="url"/>
          <label for="link_url">URL</label>
        </div>

        <small v-if="submitted && !websiteLooksValid(linkData.url)" class="p-invalid">
          {{ $t('Invalid website') }}
        </small>
      </div>

      <div class="p-field p-col-12 p-mb-5">
        <div class="p-float-label">
          <InputText id="link_username" v-model.trim="linkData.username" autocomplete="off"/>
          <label for="link_username">{{ $t('Username') }}</label>
        </div>
      </div>
      <div class="p-field p-col-12 p-mb-5">
        <div class="p-float-label">
          <InputText id="link_password" v-model.trim="linkData.password" autocomplete="off"/>
          <label for="link_password">{{ $t('Password') }}</label>
        </div>
      </div>
      <div class="p-field p-col-12 p-mb-5">
        <div class="p-float-label">
          <MultiSelect id="access-modal-users"
                       @show="toggleDropdownOverlayVisibility(true)"
                       @hide="toggleDropdownOverlayVisibility(false)"
                       v-model="selectedUsers"
                       ref="selectedUsersDropdown"
                       :options="usersData"
                       optionLabel="full_name"
                       :filter="true"
                       class="ms-multiline"
                       display="chip"/>
          <label for="access-modal-users">{{ $t('Access') }}</label>
        </div>
      </div>
      <div class="p-field p-col-12">
        <div class="p-float-label p-input-icon-right">
          <i class="ti-comment-alt" />
          <Textarea id="link_comment" v-model="linkData.comment" rows="3" :autoResize="true" autocomplete="off"/>
          <label for="link_comment">{{ $t('Comment') }}</label>
        </div>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :label="$t('Save')" :disabled="disableSaveButton" icon="pi pi-check" class="p-button-text" @click="saveItem"/>
    </template>
  </Modal>
</template>

<script>
import httpClient from '@/services/http.services'
import overlayVisibilityMixins from "@/mixins/overlayVisibilityMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";

export default {
  mixins: [ overlayVisibilityMixins, showErrorsMixins, formatMixins ],
  emits: ['close', 'update-items'],
  name: 'SupplierAccountsModal',
  props: {
    item: Object,
    visible: Boolean,
    linkUsers: {
      type: [Array, null],
      default: null,
    }
  },
  data() {
    return {
      passwordIsLoading: false,
      dataIsSending: false,
      disableSaveButton: false,
      selectedUsers: [],
      usersData: [],
      // updateUsers: false,
      removeAllUsers: false,
      linkData: {},
      submitted: false,
      isDefault: false
    }
  },
  watch: {
    '$store.state.dropdownOverlayVisible'(value) {
      if (!value) {
        this.$refs.selectedUsersDropdown?.hide()
      }
    },
    item(value) {
      if (!value) return
      this.linkData = { ...value }

      if (value.users?.length) {
        const sortedUsers = [...value.users]
            .map(m => ({ ...m, id: m.userData?.id ? +m.userData?.id : 0 }))  // нормализуем id в masters
            .filter(m => m.id > 0)
            .sort((a, b) => a.id - b.id);

        this.selectedUsers = sortedUsers.map(user => {
          const id = user.id;
          const full_name = `${user.userData?.first_name ?? ''} ${user.userData?.last_name ?? ''}`.trim();

          const exists = this.usersData.find(m => +m.id === id);
          const masterData = { id, full_name };

          if (!exists) this.usersData.push(masterData);

          return masterData;
        });
      } else {
        this.selectedUsers = []
      }
    },
    visible(value) {
      if (!value) {
        this.disableSaveButton = false
        this.dataIsSending = false
        this.submitted = false
        this.selectedUsers = []
        this.passwordIsLoading = false
      } else {
        if (!this.item?.password) this.getPassword()
      }
    },
    linkUsers(value) {
      this.usersData = Array.isArray(value) ? [...value] : []
    },
  },
  methods: {
    async getPassword() {
      if (!this.item?.id) return
      this.passwordIsLoading = true

      try {
        const { data, status } = await httpClient.post('link/get-password', { id: this.item.id })
        if (status === 200 && data?.success) {
          this.linkData.password = data.password ?? null
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.passwordIsLoading = false
      }
    },
    async saveItem() {
      this.submitted = true

      if (!this.linkData.name || !this.websiteLooksValid(this.linkData.url)) {
        return false
      }

      this.disableSaveButton = true
      this.dataIsSending = true

      const link = {
        name: this.linkData.name ?? null,
        url: this.normalizeUrl(this.linkData.url) || null,
        username: this.linkData.username ?? null,
        password: this.linkData.password ?? null,
        comment: this.linkData.comment ?? null,
        userIds: this.selectedUsers?.length ? this.selectedUsers.map(user => user.id) : null
      }

      if (this.linkData?.id) {
        link.id = this.linkData.id
        try {
          const { status, data } = await httpClient.post(`link/update`, link)
          if (status === 200 && data?.success) {
            this.$emit('update-items', this.linkData.id)
            this.$toast.add({severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife});
            this.close()
          } else if (data.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife})
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      } else {
        try {
          const { status, data } = await httpClient.post(`link/create`, link)
          if (status === 201 && data?.success) {
            this.linkData.id = data.id
            link.id = data.id
            this.$emit('update-items', this.linkData.id)
            this.$toast.add({severity:'success', detail: this.$t('Data saved'), life: settings.toastLife});
            this.close()
          } else if (data.error) {
            this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife})
          }
        } catch(err) {
          this.showError(err)
        } finally {
          this.dataIsSending = false
          this.disableSaveButton = false
        }
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '460px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '460px', marginTop: '25px'}
      } else {
        return {position: 'absolute', top: 0, width: '460px', marginTop: '50px'}
      }
    },
  },

}
</script>